import { Amplify } from 'aws-amplify';
import { amplifyConfig } from '../amplify-config';

// Initialize Amplify with our configuration for v6
export const configureAmplify = () => {
  // Configure Amplify with our REST API endpoint
  Amplify.configure({
    API: {
      REST: {
        contactAPI: {
          endpoint: amplifyConfig.API.endpoints[0].endpoint,
          region: amplifyConfig.API.endpoints[0].region
        }
      }
    }
  });
};

export default configureAmplify;